import { createAction } from 'redux-act';

export const closePopup = createAction('Close popup');
export const togglePopup = createAction('Toggle popup');
export const setImage = createAction('Set image');
